module.exports = __webpack_public_path__ + "img/Mahjong_logo.d393a548.png";